import type { MouseEvent } from 'react'

import type { FanResponseDto, VaultMediaItemDto } from '@api'

import type { Message } from '@/modules/chatting/types.ts'

export type StreamableVaultMedia = VaultMediaItemDto & {
  isExpirable?: boolean
  relatedMessageId?: Message['id']
  relatedUserId?: FanResponseDto['id']
}

export interface ClonesResponse {
  clonesByOriginal: {
    [originalId: number]: number[]
  }
}

export interface UploadedMediaAction {
  text: string
  onClick: (event: MouseEvent<HTMLDivElement>) => void
}

export enum OverlayIconsTypes {
  posted = 'posted',
  bought = 'bought',
  sentFree = 'sentFree',
  sent = 'sent',
}

export interface UploadFileItem {
  id: string
  uploadingProgress: number
  isUploading: boolean
  file: File
}
